/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
//= require search/widgets

window.ProductWidgets = {
  _list: '',

  getQuery(user_id, company_id, controller) {
    let query;
    this._list = $('#products-smart-lists ul#quick-lists li a.selected').data('type');

    if ((this._list === 'all-products') || (this._list === undefined)) {
      query = '';
    } else if ((this._list === 'approved') && (controller === 'products')) {
      query = "developer_ids=" + company_id;
    } else {
      query = this._list + '=' + user_id;
    }
    return query;
  },

  quickListWidget() {
    return {
      init(options) {
        return $(document).on('click', '#products-smart-lists ul#quick-lists li:not(.saved_search) a', () => options.helper.setQuery('').search());
      }
    };
  },

  categoryWidget() {
    return instantsearch.widgets.hierarchicalMenu({
      container: '#product-categories',
      attributes: ['categories.lvl0', 'categories.lvl1', 'categories.lvl2', 'categories.lvl3'],
      limit: 50
    });
  },

  manufacturerWidget() {
    return instantsearch.widgets.refinementList({
      container: '#manufacturer',
      attribute: 'manufacturer',
      operator: 'or',
      limit: 10,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined'],
      templates: {
        item: Widgets.refinementListTemplate
      }
    });
  },

  supplierWidget(attribute) {
    return instantsearch.widgets.refinementList({
      container: '#supplier',
      attribute,
      operator: 'or',
      limit: 10,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined'],
      templates: {
        item: Widgets.refinementListTemplate
      }
    });
  },

  collectionWidget() {
    return instantsearch.widgets.refinementList({
      container: '#collection',
      attribute: 'collection',
      operator: 'or',
      limit: 10,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined'],
      templates: {
        item: Widgets.refinementListTemplate
      }
    });
  },

  certificatesWidget() {
    return instantsearch.widgets.refinementList({
      container: '#certificates',
      attribute: 'certificates',
      operator: 'or',
      limit: 10,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined'],
      templates: {
        item: Widgets.refinementListTemplate
      }
    });
  },

  hitsWidget(user_id, companyId) {
    let listClasses = 'vcard-list items grid borders ais-Hits-list';
    if (user_id && (typeof GridListToggler !== 'undefined') && (GridListToggler.getViewMode() === 'grid')) {
      listClasses += ' vertical';
    }

    return instantsearch.widgets.infiniteHits({
      empty: 'Oops, no results were found',
      container: '#products-list-container',
      cssClasses: {
        item: ['vcard-list-item item'],
        root: 'ais-Hits',
        list: listClasses
      },
      transformItems(items) {
        return items.map(function (item) {
          if (user_id) {
            item.tagged = item.user_tags[user_id];
          }
          if (companyId && (ProductWidgets._list === 'approved')) {
            const approval = _.find(item.approvals, { developer_id: Number(companyId) });
            if (approval) {
              item.price = approval.price;
            }
          }
          if (item.follower_ids.indexOf(Number(user_id)) >= 0) {
            item.liked = true;
          }
          if (item.projects_count > 5) {
            item.projects_data = item.projects_data.slice(0, 5);
            item.hidden_projects_count = item.projects_count - 5;
          }
          item.my_product = item.company_id === parseInt(companyId);
          return item;
        });
      },
      templates: {
        item: $("#product-template").text(),
        empty: $('#no-search-results-found-template').text()
      }
    });
  }

};
